import { render, staticRenderFns } from "./UsersDialog.vue?vue&type=template&id=01870cd3"
import script from "./UsersDialog.vue?vue&type=script&lang=js"
export * from "./UsersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports